<template>
  <div class="animated fadeIn">
    <b-card no-body>
      <b-card-header>
        <i class="fa fa-list mr-2"></i><strong>Liste des Grilles de Salaire</strong>
      </b-card-header>
      <b-card-body>
        <v-client-table :columns="columns" :data="data" :options="options">
          <div slot="created_at" slot-scope="props" class="slot-date">
            <span class="badge badge-success p-2">{{ formatDate(props.row.created_at) }}</span>
          </div>
          <div slot="action" slot-scope="props">
            <b-button v-if="canManageFamilleProduit()" type="button" @click.prevent="destroy(props.row.id)" class="badge badge-danger mr-3 p-2"><i
              class="fa fa-remove"></i> Supprimer
            </b-button>
            <b-button v-if="canManageFamilleProduit()" type="button" @click="edit(props.row.id)" class="badge badge-primary p-2">
              <i class="fa fa-edit"></i> Modifier
            </b-button>
          </div>
        </v-client-table>
      </b-card-body>

      <div slot="footer">
        <b-button v-if="canManageFamilleProduit()" type="button" @click="add" class="pull-right" size="md" variant="primary">
          <i class="fa fa-plus"></i> Ajouter une grille
        </b-button>
      </div>
    </b-card>
  </div>
</template>

<script>
import { getBaseUrl, getProvider, getIdToken, getAccessToken } from '@/utils/auth'
import { formatDate } from "@/utils/communHelper"
import { hasRule, espaceGestionRules as rules } from '@/utils/rulesHelper'

export default {
  name: "List",
  data() {
    return {
      columns: ['created_at', 'libelle', 'nb_mois', 'mois_reference', 'action'],
      data: [],
      options: {
        headings: {
          'created_at': 'Date de création',
          'libelle': 'Libellé',
          'nb_mois': 'Nombre de mois',
          'mois_reference': 'Mois de référence'
        },
        columnsClasses: {
          action: 'action-md',
        },
        sortable: ['created_at'],
        filterable: false,
        perPage: 10,
        perPageValues: [10, 25, 50],
        orderBy: {column: 'libelle', ascending: false}
      },
      formatDate,
    }
  },
  mounted() {
    this.all()
  },
  created() {
    this.$axios.defaults.baseURL = getBaseUrl();
    this.$axios.defaults.headers.common["Authorization"] = getIdToken() + " " + getAccessToken();
    this.$axios.defaults.headers.common["Accept"] = "application/json";
    this.$axios.defaults.headers.common["Provider"] = getProvider();
  },
  methods: {
    all() {
      this.$store.commit('IS_LOADING', true)
      this.$axios
        .get("/espaceGestion/produit/gestion-grille")
        .then(response => {
          this.$store.commit("IS_LOADING", false)
          this.data = response.data.grillesSalaire
        })
        .catch(() => {
          this.$store.commit("IS_LOADING", false)
          this.handleError()
        });
    },
    canManageFamilleProduit() {
      return hasRule(rules.CAN_MANAGE_PRODUIT)
    },
    destroy(id) {
      this.$swal
        .fire({
          title: 'Êtes-vous sûr?',
          text: "Voulez-vous vraiment supprimer cette grille de salaire ?",
          type: 'warning',
          reverseButtons: true,
          showCancelButton: true,
          cancelButtonColor: "#ff1744",
          confirmButtonText: 'Annuler',
          cancelButtonText: 'Supprimer',
        })
        .then((result) => {
          if (!result.value) {
            this.$store.commit('IS_LOADING', true)
            this.$axios
              .delete("/espaceGestion/produit/gestion-grille/delete/" + id)
              .then(() => {
                this.$store.commit('IS_LOADING', false)
                this.$swal({
                  position: 'top',
                  type: 'success',
                  title: 'Suppression avec succès',
                  text: "La grille de salaire a bien été supprimée",
                  showConfirmButton: false,
                  timer: 5000
                });
                this.all();
              })
              .catch((error) => {
                this.$store.commit("IS_LOADING", false);
                if (error.response.status == 401) {
                  this.$swal({
                    position: 'top',
                    type: 'warning',
                    title: 'Attention !!',
                    text: error.response.data.message,
                    showConfirmButton: false,
                    timer: 5000
                  });
                } else {
                  this.handleError();
                }
              })
          }
        })

    },
    add() {
      this.$router.push({path: '/espace-gestion/produit/gestion-grille/add'})
    },
    edit(id) {
      this.$router.push({path: '/espace-gestion/produit/gestion-grille/edit/' + id})
    },
    handleError() {
      this.$swal({
        position: 'top',
        type: 'error',
        title: 'Attention !!',
        text: 'Un problème est survenu, merci de contacter l\'administrateur',
        showConfirmButton: false,
        timer: 5000
      });
    }
  }
}
</script>

<style scoped>

</style>
